export const setConditions = [
  {key: 0, val: 'new', label: 'New - Unopened Box'},
  {key: 1, val: 'opened', label: 'Opened Box - Complete Set'},
  {key: 2, val: 'incomplete', label: 'Incomplete'}
]
